export default {
    isAuth: false,
    token: '',
    user: {
      userId: '',
      isAdmin: false
    },
    posts:[],
    loading: true,
    noPosts: false,
    page: 0,
    pageType: null,
    tag:'',
    info: '',
    saving: false,
    year: '',
    years: [],
    imageModalSrc: '',
    mediaType: 'all'  // 'all', 'image' or 'video' - for tab filtering
  }